import { useState } from 'react'
import SchoolTeacherHeader from '../header'
import SchoolTeacherSidebar from '../sidebar'
import { Icon1, Icon2, User5, course03 } from '../../imagepath'
import { Link } from 'react-router-dom'

const SchoolTeacherDashboard = () => {

    const [isClassAdded, setIsClassAdded] = useState([false]);

    const toggleClass = (index) => {
      const updatedClasses = [...isClassAdded];
      updatedClasses[index] = !updatedClasses[index];
      setIsClassAdded(updatedClasses);
    };
    return (
        <>
            {/* Main Wrapper */}
            <div className="main-wrapper">
                {/* Header */}
                <SchoolTeacherHeader activeMenu={"Dashboard"} />
                {/* /Header */}
                {/* Breadcrumb */}
                <div className="breadcrumb-bar breadcrumb-bar-info">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="breadcrumb-list">
                                    <h2 className="breadcrumb-title">School Teacher Dashboard</h2>
                                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="#">Home</Link>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">
                                                Dashboard
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Page Content */}
                <div className="page-content">
                    <div className="container">
                        <div className="row">
                            {/* sidebar */}
                            <SchoolTeacherSidebar />
                            {/* /Sidebar */}
                            {/* School Dashboard */}
                            <div className="col-xl-9 col-lg-9">
                                {/* Dashboard Grid */}
                                <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        {/* <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Enrolled Courses</h5>
                                                <h2>1</h2>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        {/* <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Active Courses</h5>
                                                <h2>0</h2>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        {/* <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Completed Courses</h5>
                                                <h2>0</h2>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                {/* /Dashboard Grid */}
                                {/* <div className="dashboard-title">
                                    <h4>Recently Enrolled Courses</h4>
                                </div>
                                <div className="row">
                                    <div className="col-xxl-4 col-md-6 d-flex">
                                        <div className="course-box flex-fill">
                                            <div className="product">
                                                <div className="product-img">
                                                    <Link to="/course-details">
                                                        <img
                                                            className="img-fluid"
                                                            alt="Img"
                                                            src={course03}
                                                        />
                                                    </Link>
                                                    <div className="price combo">
                                                        <h3>$300</h3>
                                                    </div>
                                                </div>
                                                <div className="product-content">
                                                    <div className="course-group d-flex">
                                                        <div className="course-group-img d-flex">
                                                            <Link to="/earlylearningcenter/earlylearningcenter-profile">
                                                                <img
                                                                    src={User5}
                                                                    alt="Img"
                                                                    className="img-fluid"
                                                                />
                                                            </Link>
                                                            <div className="course-name">
                                                                <h4>
                                                                    <Link to="/earlylearningcenter/earlylearningcenter-profile">Jenny</Link>
                                                                </h4>
                                                                <p>Early Learning Center</p>
                                                            </div>
                                                        </div>
                                                        <div className="course-share d-flex align-items-center justify-content-center">
                                                        <Link to="#" onClick={() => toggleClass(2)}>
                                                        <i className={`fa-regular fa-heart ${isClassAdded[2] ? 'color-active' : ''}`} />
                                                      </Link>
                                                        </div>
                                                    </div>
                                                    <h3 className="title earlylearningcenter-text">
                                                        <Link to="/course-details">
                                                            Sketch from A to Z (2024): Become an app designer
                                                        </Link>
                                                    </h3>
                                                    <div className="course-info d-flex align-items-center">
                                                        <div className="rating-img d-flex align-items-center">
                                                            <img src={Icon1} alt="Img" />
                                                            <p>10+ Lesson</p>
                                                        </div>
                                                        <div className="course-view d-flex align-items-center">
                                                            <img src={Icon2} alt="Img" />
                                                            <p>40hr 10min</p>
                                                        </div>
                                                    </div>
                                                    <div className="rating mb-0">
                                                        <i className="fas fa-star filled me-1" />
                                                        <i className="fas fa-star filled me-1" />
                                                        <i className="fas fa-star filled me-1" />
                                                        <i className="fas fa-star me-1" />
                                                        <i className="fas fa-star me-1" />
                                                        <span className="d-inline-block average-rating">
                                                            <span>3.0</span> (18)
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="dash-pagination">
                                    <div className="row align-items-center">
                                        <div className="col-6">
                                            <p>Page 1 of 2</p>
                                        </div>
                                        <div className="col-6">
                                            <ul className="pagination">
                                                <li className="active">
                                                    <Link to="#">1</Link>
                                                </li>
                                                <li>
                                                    <Link to="#">2</Link>
                                                </li>
                                                <li>
                                                    <Link to="#">
                                                        <i className="bx bx-chevron-right" />
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            {/* School Dashboard */}
                        </div>
                    </div>
                </div>
                {/* /Page Content */}
                {/* Footer */}

                {/* /Footer */}
            </div>
            {/* /Main Wrapper */}
        </>

    )
}

export default SchoolTeacherDashboard
